import gql from 'graphql-tag'

export const YELLOWCOMPANY = gql`
query{ 
 yellowCompany{
  _id
  companyName
  appliedEmails
  nortificationEmails
  notifyExpire
  point
  blacklist
  grayStatus
  darkGrayStatus
  yellowStatus
	orderedBy{
			isOwner
			email
		}
}
}
`

export const YELLOWLIST_EMPLOYER = gql`
 mutation(
  $employerId:ID
  $reasonRequest: String
  $files:[String]
){  requestYellowlist(info:{
    employerId: $employerId
    reasonRequest:$reasonRequest
	files:$files
  })
  }
    `

export const UPDATE_YELLOWLIST_EMPLOYER = gql`
mutation(
$_id:ID
 $employerId:ID
 $reasonRequest: String
 $files:[String]
){  updateYellowlist(info:{
	_id:$_id
   employerId: $employerId
   reasonRequest:$reasonRequest
   files:$files
 })
 }
 `

export const UNYELLOWLIST_EMPLOYER = gql`
mutation(
$_id:ID
){  unLockYellowList(info:{
	_id:$_id
 })
 }
 `

export const GET_YELLOWLIST = gql`
 query(
	$page:Int
	$perPage:Int
	$search:Boolean
){
	get_YellowList(page:$page perPage:$perPage search:$search){
		info{
			_id
			logo
			companyName
			reasonRequest
			createdAt
			files
			auth
		}
	}
}
 `

export const GETYELLOWBYID = gql`
 query(
	$_id:ID
){
	getYellowListById(_id:$_id){
			_id
			logo
			employerId
			companyName
            reasonRequest
			createdAt
			files
			auth
	}
}
 `
